(function(){
  'use strict';

  var KOMMO_ENDPOINT='https://hook.us2.make.com/rhyk0s0gemnk1ljv8sdgt549a1alvdbg';
  var LEAD_KEY='brandlabLead';
  var SUBMISSION_KEY='brandlabSubmission';
  var ATTR_SHEET_URL='https://script.google.com/macros/s/AKfycbzPM6E9eSn1SFAUe8NaZYQAy5Gzrvk10PXLXsUXfBwGTlZg7YfXX2IS98aoxxE9LW1pEQ/exec';

  function q(s,r){return(r||document).querySelector(s)}
  function qa(s,r){return Array.from((r||document).querySelectorAll(s))}
  function publish(name,data){
    try{if(window.Shopify&&Shopify.analytics&&typeof Shopify.analytics.publish==='function')Shopify.analytics.publish(name,data||{})}catch(e){}
    try{window.dataLayer=window.dataLayer||[];window.dataLayer.push(Object.assign({event:name},data||{}))}catch(e){}
  }
  function mobile(){
    try{if(navigator.userAgentData&&typeof navigator.userAgentData.mobile==='boolean')return navigator.userAgentData.mobile}catch(e){}
    var ua=navigator.userAgent||'';
    return /Android|iPhone|iPod|IEMobile|Opera Mini|Mobile/i.test(ua)||(/Macintosh/i.test(ua)&&navigator.maxTouchPoints>1)
  }
  function hidden(form,name){
    var el=q('[name="'+name+'"]',form);
    if(!el){el=document.createElement('input');el.type='hidden';el.name=name;form.appendChild(el)}
    return el
  }
  function levelForQty(v){
    var select=document.getElementById('bl-contact-quantity');
    var plan=document.getElementById('bl-plan-interest');
    return plan&&plan.value?plan.value:'Sin definir'
  }
  function origin(){
    var o={code:'',src:'',med:'',camp:'',cont:''};
    try{
      if(typeof window.TC_ORIGEN==='function'){
        var tc=window.TC_ORIGEN()||{};
        o.code=tc.code||'';
        o.src=tc.src||'';
        o.med=tc.med||'';
        o.camp=tc.camp||'';
        o.cont=tc.cont||''
      }
    }catch(e){}
    try{
      var p=new URLSearchParams(location.search);
      o.src=p.get('utm_source')||o.src;
      o.med=p.get('utm_medium')||o.med;
      o.camp=p.get('utm_campaign')||o.camp;
      o.cont=p.get('utm_content')||o.cont;
      o.code=p.get('ref')||p.get('tc_ref')||o.code;
      if(o.code||o.src||o.med||o.camp||o.cont)sessionStorage.setItem('brandlabUtm',JSON.stringify(o));
      else o=Object.assign(o,JSON.parse(sessionStorage.getItem('brandlabUtm')||'{}'))
    }catch(e){}
    return o
  }
  function collect(form){
    var d={};
    qa('input,select,textarea',form).forEach(function(el){if(el.name)d[el.name]=el.value||''});
    return d
  }
  function refreshHidden(form){
    var o=origin(),isMobile=mobile(),qty=q('[name="contact[Cantidad aproximada]"]',form);
    var plan=q('[name="contact[Plan de interes]"]',form);
    if(plan&&!plan.value)plan.value=levelForQty(qty?qty.value:'');
    hidden(form,'contact[Origen]').value='Web - Landing Brand Lab';
    hidden(form,'contact[Landing]').value='Brand Lab';
    hidden(form,'contact[Servicio]').value='Personalizado Maquila';
    hidden(form,'contact[Canal de seguimiento]').value=isMobile?'WhatsApp':'Correo';
    hidden(form,'contact[Dispositivo]').value=isMobile?'Móvil / tablet':'Computadora';
    hidden(form,'contact[Referencia]').value=o.code||'';
    hidden(form,'contact[UTM source]').value=o.src||'';
    hidden(form,'contact[UTM medium]').value=o.med||'';
    hidden(form,'contact[UTM campaign]').value=o.camp||'';
    hidden(form,'contact[UTM content]').value=o.cont||''
  }
  function leadMessage(d){
    var name=d['contact[name]']||'';
    var studio=d['contact[Empresa o marca]']||'';
    var type=d['contact[Tipo de proyecto]']||'';
    var qty=d['contact[Cantidad aproximada]']||'';
    var date=d['contact[Fecha objetivo]']||'';
    var phone=d['contact[phone]']||'';
    var email=d['contact[email]']||'';
    var notes=d['contact[body]']||'';
    var level=d['contact[Plan de interes]']||'';
    var ref=d['contact[Referencia]']||origin().code||'';
    var lines=['Hola, soy '+name+(studio?' de '+studio:'')+'. Vengo de la web de Tu Calcetín, de la sección Brand Lab.'];
    if(qty)lines.push('Cantidad aproximada: '+qty+'.');
    if(type)lines.push('Tipo de proyecto: '+type+'.');
    if(level&&level!=='Sin definir')lines.push('Plan de interés: '+level+'.');
    if(date)lines.push('Fecha objetivo: '+date+'.');
    if(notes)lines.push('Sobre mi proyecto: '+notes);
    if(phone)lines.push('Mi WhatsApp registrado es '+phone+'.');
    if(email)lines.push('Mi correo es '+email+'.');
    if(ref)lines.push('Referencia web: '+ref+'.');
    lines.push('Me gustaría continuar mi cotización.');
    return lines.join('\n')
  }
  function waNumber(root){
    var wrap=root&&root.closest?root.closest('[data-bl-contact-wrap]'):q('[data-bl-contact-wrap]');
    return wrap?String(wrap.dataset.waNumber||'').replace(/[^0-9]/g,''):''
  }
  function waUrl(number,data){
    return number?'https://wa.me/'+number+'?text='+encodeURIComponent(leadMessage(data||{})):''
  }
  function kommoPayload(data){
    return{
      name:data['contact[name]']||'',
      studio:data['contact[Empresa o marca]']||'',
      phone:data['contact[phone]']||'',
      email:data['contact[email]']||'',
      type:data['contact[Tipo de proyecto]']||'',
      quantity:data['contact[Cantidad aproximada]']||'',
      date:data['contact[Fecha objetivo]']||'',
      notes:data['contact[body]']||'',
      level:data['contact[Plan de interes]']||'',
      origin:data['contact[Origen]']||'Web - Landing Brand Lab',
      landing:data['contact[Landing]']||'Brand Lab',
      service:data['contact[Servicio]']||'Personalizado Maquila',
      channel:data['contact[Canal de seguimiento]']||'',
      device:data['contact[Dispositivo]']||'',
      reference:data['contact[Referencia]']||'',
      utm:{
        source:data['contact[UTM source]']||'',
        medium:data['contact[UTM medium]']||'',
        campaign:data['contact[UTM campaign]']||'',
        content:data['contact[UTM content]']||''
      }
    }
  }
  function makeBody(data){
    var payload=kommoPayload(data),body=new URLSearchParams();
    Object.keys(payload).forEach(function(key){
      if(key==='utm'){
        Object.keys(payload.utm).forEach(function(k){body.set('utm_'+k,payload.utm[k]||'')})
      }else body.set(key,payload[key]||'')
    });
    body.set('submission_id',readReceipt().id||'');
    return body.toString()
  }
  function readReceipt(){
    try{return JSON.parse(sessionStorage.getItem(SUBMISSION_KEY)||'{}')||{}}catch(e){return{}}
  }
  function writeReceipt(patch){
    try{
      var current=readReceipt();
      Object.keys(patch||{}).forEach(function(k){current[k]=patch[k]});
      sessionStorage.setItem(SUBMISSION_KEY,JSON.stringify(current));
      return current
    }catch(e){return patch||{}}
  }
  function syncKommoInBackground(data){
    if(!KOMMO_ENDPOINT||typeof window.fetch!=='function')return;
    try{
      fetch(KOMMO_ENDPOINT,{
        method:'POST',
        mode:'cors',
        credentials:'omit',
        cache:'no-store',
        keepalive:true,
        headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8','Accept':'application/json'},
        body:makeBody(data)
      }).then(function(response){
        if(!response.ok)throw new Error('Kommo endpoint HTTP '+response.status);
        return response.text().then(function(text){
          var result=null;
          if(text){try{result=JSON.parse(text)}catch(e){result=null}}
          var leadId=result&&((result.leadId||result.lead_id)||'');
          if(result&&result.ok===true&&/^\d+$/.test(String(leadId))&&Number(leadId)>0){
            writeReceipt({kommoState:'confirmed',leadId:String(leadId),contactId:String(result.contactId||result.contact_id||'')});
            publish('brandlab_kommo_success',{lead_id:String(leadId)});
          }else if(result&&result.ok===false){
            writeReceipt({kommoState:'unconfirmed'});
            publish('brandlab_kommo_unconfirmed',{message:String(result.error||result.message||'Make no confirmó la solicitud').slice(0,120)})
          }else{
            writeReceipt({kommoState:'accepted'});
            publish('brandlab_kommo_accepted',{accepted:true})
          }
        })
      }).catch(function(err){
        writeReceipt({kommoState:'error'});
        publish('brandlab_kommo_error',{message:String(err&&err.message||'error').slice(0,120)})
      })
    }catch(e){
      writeReceipt({kommoState:'error'})
    }
  }
  function registerAttributionFolio(data){
    try{
      var r=window.TC_ATTR||{};
      if(!ATTR_SHEET_URL||r.reg)return;
      var o=origin();
      var t=(r.last&&r.last.p)||{};
      var folio=(data&&data['contact[Referencia]'])||o.code||'';
      if(!folio)return;
      var payload={
        folio:folio,
        source:o.src||'',
        medium:o.med||'',
        campaign:o.camp||'',
        content:o.cont||'',
        term:t.utm_term||'',
        page:location.pathname,
        fbclid:t.fbclid||'',
        ref:(r.last&&r.last.ref)||''
      };
      var qs=Object.keys(payload).map(function(k){return k+'='+encodeURIComponent(payload[k]||'')}).join('&');
      new Image().src=ATTR_SHEET_URL+'?'+qs;
      r.reg=true;
      window.TC_ATTR=r;
      localStorage.setItem('tc_attr',JSON.stringify(r))
    }catch(e){}
  }
  function waAnalytics(data,automatic){
    var o=origin();
    registerAttributionFolio(data);
    var payload={
      source:o.src||'',
      medium:o.med||'',
      campaign:o.camp||'',
      content:o.cont||'',
      ref_code:(data&&data['contact[Referencia]'])||o.code||'',
      page:location.pathname,
      lead_source:'Landing Brand Lab',
      automatic:automatic===true,
      brandlab:true
    };
    publish('brandlab_whatsapp_open_attempt',payload);
    publish('wa_click',payload)
  }
  function markWaOpened(){
    writeReceipt({waOpened:true,waOpenedAt:Date.now()})
  }
  function openWa(url,data,automatic){
    if(!url)return;
    markWaOpened();
    waAnalytics(data,automatic);
    if(automatic||mobile())location.href=url;
    else window.open(url,'_blank','noopener')
  }
  function bindForm(root){
    var form=(root&&root.matches&&root.matches('#brandlab-form'))?root:q('#brandlab-form',root&&root.querySelector?root:document);
    if(!form||form.dataset.blHybridBound||q('[data-bl-success]',form))return;
    form.dataset.blHybridBound='1';
    refreshHidden(form);

    var qty=q('[name="contact[Cantidad aproximada]"]',form);
    if(qty)qty.addEventListener('change',function(){refreshHidden(form)});

    var started=false;
    function recordStart(){
      if(started)return;
      started=true;
      publish('brandlab_form_start',{page:'brandlab'})
    }
    form.addEventListener('input',recordStart);
    form.addEventListener('change',recordStart);

    form.addEventListener('submit',function(e){
      if(!form.checkValidity()){e.preventDefault();form.reportValidity();return}
      if(form.dataset.blHybridSubmitting==='1'){e.preventDefault();return}
      e.preventDefault();
      form.dataset.blHybridSubmitting='1';
      refreshHidden(form);
      hidden(form,'contact[Resumen para Kommo]').value=leadMessage(collect(form));
      var data=collect(form);
      var submission={
        id:Date.now().toString(36)+'-'+Math.random().toString(36).slice(2),
        createdAt:Date.now(),
        kommoState:'pending',
        waOpened:false
      };
      try{
        sessionStorage.setItem(LEAD_KEY,JSON.stringify(data));
        sessionStorage.setItem(SUBMISSION_KEY,JSON.stringify(submission))
      }catch(e){}
      publish('brandlab_form_attempt',{
        quantity:data['contact[Cantidad aproximada]']||'',
        type:data['contact[Tipo de proyecto]']||'',
        level:data['contact[Plan de interes]']||'',
        channel:data['contact[Canal de seguimiento]']||''
      });
      syncKommoInBackground(data);

      var submit=q('button[type="submit"]',form);
      if(submit){
        var label=submit.textContent;
        submit.disabled=true;
        submit.textContent='Enviando solicitud...';
        setTimeout(function(){
          if(document.visibilityState==='visible'){
            submit.disabled=false;
            submit.textContent=label||'Solicitar cotización';
            form.dataset.blHybridSubmitting=''
          }
        },9000)
      }

      
      try{HTMLFormElement.prototype.submit.call(form)}catch(err){form.submit()}
    })
  }
  function bindSuccess(root){
    var success=(root&&root.matches&&root.matches('[data-bl-success]'))?root:q('[data-bl-success]',root&&root.querySelector?root:document);
    if(!success||success.dataset.blHybridSuccessBound)return;
    success.dataset.blHybridSuccessBound='1';
    success.setAttribute('aria-live','polite');
    success.setAttribute('tabindex','-1');

    var receipt=readReceipt();
    var data={};
    try{data=JSON.parse(sessionStorage.getItem(LEAD_KEY)||'{}')||{}}catch(e){}
    var number=waNumber(success);
    var url=waUrl(number,data);
    var btn=q('[id="bl-whatsapp-followup"]',success);
    var autoTimer=null;
    var opened=receipt.waOpened===true;

    publish('brandlab_shopify_success',{
      lead_source:'Landing Brand Lab',
      submission_id:receipt.id||'',
      kommo_state:receipt.kommoState||'unknown'
    });
    publish('generate_lead',{
      lead_source:'Landing Brand Lab',
      channel:mobile()?'whatsapp':'email',
      submission_id:receipt.id||'',
      kommo_state:receipt.kommoState||'unknown'
    });

    if(btn){
      if(url){
        btn.href='#';
        btn.removeAttribute('target');
        btn.removeAttribute('rel');
        btn.addEventListener('click',function(e){
          e.preventDefault();
          if(autoTimer)clearTimeout(autoTimer);
          opened=true;
          openWa(url,data,false)
        })
      }else{
        btn.style.display='none'
      }
    }

    setTimeout(function(){
      try{success.scrollIntoView({behavior:'smooth',block:'center'})}catch(e){}
      try{success.focus({preventScroll:true})}catch(e){try{success.focus()}catch(ignore){}}
    },80);

    if(mobile()&&url&&Object.keys(data).length&&!opened){
      autoTimer=setTimeout(function(){
        if(opened)return;
        opened=true;
        openWa(url,data,true)
      },1100)
    }
  }
  function bind(root){bindForm(root||document);bindSuccess(root||document)}
  bind(document);
  document.addEventListener('shopify:section:load',function(e){setTimeout(function(){bind(e.target)},0)});
})();

